<div #singleDonut role="group" tabindex="0" [attr.aria-label]="(chartAltText || (config?.title ? config.title + ' chart' : 'chart')) + '. Press Enter to navigate into chart'" (keydown)="onContainerKeydown($event)"></div>
